import { render, staticRenderFns } from "./UseFlowTemplatePanel.vue?vue&type=template&id=bcc62bc6&"
import script from "./UseFlowTemplatePanel.vue?vue&type=script&lang=js&"
export * from "./UseFlowTemplatePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports